import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Option = styled.div.attrs(p => ({
    style: {
        width: (p && p.width) ? p.width : '100%',
        justifyContent: (p && p.justify) ? p.justify : 'stretch',
    }
}))`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 5px 0 15px;
    cursor: pointer;
    
    &.solo {
        margin: 0;
    }

    &.small {
        margin: 5px 0 0 0;
    }

    &.variant {
        margin: 0 0 10px 0;
    }
`;

const Label = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    font-size: 12px;
    text-transform: uppercase;
    color: #999;

    .variant & {
        color: #fff;
        font-size: 14px;
        text-transform: none;
    }
`;

const Checkbox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    width: 20px;
    height: 20px;
    border: 1px solid #999;
    background-color: transparent;
    position: relative;
    margin-right: 10px;

    .variant & {
        background-color: #111;
        margin-right: 5px;
    }

    ${Option}.solo & {
        margin-right: 0;
    }

    ${Option}.small & {
        margin-right: 0;
        width: 15px;
        height: 15px;
    }

    &.active:before {
        content: '';
        position: absolute;
        top: 3px;
        left: 3px;
        bottom: 3px;
        right: 3px;
        background-color: #bbb;
    }
`;

export default ({onClick, children, value, ...props}) => {
    const [checked, setChecked] = useState(value || false);
    const className = props.className ?? '';
    const width = props.width ?? null;
    const justify = props.justify ?? null;

    useEffect(() => {setChecked(value)}, [value]);

    return <Option className={className} width={width} justify={justify} onClick={(e) => {setChecked(!checked); onClick(!checked, e)}}>
        <Checkbox className={checked ? 'active' : ''}/>
        {children ? <Label>{children}</Label> : null}
    </Option>




}